module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#FAF9F5"
    }
  }, [_c('section', {
    staticClass: "pricing-table section-padding picBox"
  }, [_c('div', {
    ref: "campusTit",
    staticClass: "campusTit"
  }, [_c('div', {
    staticClass: "campusTit-top"
  }, [_c('div', {
    ref: "Campus",
    staticClass: "campusTit-top-text",
    on: {
      "click": function($event) {
        return _vm.swiperChange('1')
      }
    }
  }, [_vm._v("CAMPUS SCENERY")]), _vm._v(" "), _c('div', {
    ref: "International",
    staticClass: "campusTit-top-text",
    on: {
      "click": function($event) {
        return _vm.swiperChange('2')
      }
    }
  }, [_vm._v("STUDENT DEMEANOR")]), _vm._v(" "), _c('div', {
    staticClass: "campusTit-bot",
    style: ({
      left: _vm.left + 'px'
    })
  })])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "pricing-table-Box",
    staticStyle: {
      "width": "100%"
    }
  }, [(_vm.bigImg.length) ? _c('gallery', {
    attrs: {
      "bigImg": _vm.bigImg
    }
  }) : _vm._e()], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-25e03622"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PricingPlan.vue
// module id = 70
// module chunks = 0